module.exports = __webpack_public_path__ + "img/avatar2.abf36f80.png";